import {
  BROADCAST_STATUSES,
  BROADCAST_TYPES,
  BULK_CALL_CAMPAIGN_STATUSES,
  BULK_CALL_RECORD_STATUSES,
} from "constants/broadcast";

export type CallDetail = {
  row_number: number;
  company_name: string;
  entity_name: string;
  team_member_name: string;
  mobile_number: string;
  original_mobile_number: string;
};

export type BroadcastCallResponse = {
  valid: boolean;
  call_count: number;
  call_details: CallDetail[];
  pagination: {
    page: number;
    page_size: number;
    total_pages: number;
    total_count: number;
    has_next: boolean;
    has_previous: boolean;
  };
};

export type BroadcastStatus =
  (typeof BROADCAST_STATUSES)[keyof typeof BROADCAST_STATUSES];

export type BroadcastType =
  (typeof BROADCAST_TYPES)[keyof typeof BROADCAST_TYPES];

export type IVRStats = {
  scheduled_calls: number;
  successful_calls: number;
  failed_calls: number;
  missed_calls: number;
  campaign_status: BulkCallCampaignStatus;
  campaign_uuid: string;
  scheduled_date: string;
  scheduled_time_start: string;
  scheduled_time_end: string;
};

export type Broadcast = {
  broadcast_id: string;
  broadcast_name: string;
  message_text: string;
  broadcast_types: BroadcastType[];
  status: BroadcastStatus;
  total_channels: number;
  total_ivr_calls: number;
  ivr_stats: IVRStats | Record<string, never>;
  created_at: string;
  completed_at: string | null;
  initiated_by: string;
};

export type BulkCallRecordStatus =
  (typeof BULK_CALL_RECORD_STATUSES)[keyof typeof BULK_CALL_RECORD_STATUSES];

export type BulkCallCampaignStatus =
  (typeof BULK_CALL_CAMPAIGN_STATUSES)[keyof typeof BULK_CALL_CAMPAIGN_STATUSES];

export type BroadcastResponse = {
  broadcasts: Broadcast[];
  pagination: {
    page: number;
    page_size: number;
    total_pages: number;
    total_count: number;
    has_next: boolean;
    has_previous: boolean;
  };
};

export type SlotValidationResponse = {
  call_count: number;
  conflicts: unknown[];
  end_time: string;
  estimated_duration_hours: number;
  scheduled_date: string;
  slot_available: boolean;
  start_time: string;
};

export const BroadcastCallFilterUpcoming = "upcoming";
export const BroadcastCallFilterAll = "all";
